import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageHeader } from '../../../../utils/models/page-header';
import { InviteeType } from '../../models/inviteetype';
import { InviteeTypeService } from '../../services/inviteetype.service';
import { CoreSaveService, ConfigService, UtilsService, MessageService, ICommonMessage, FieldType } from '@gbs-platform-client/fwk-core';
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { DatePipe } from '@angular/common';
import { APIResponse } from 'src/app/utils/models/response';
import { takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';

@Component({
  selector: 'app-inviteetype',
  templateUrl: './inviteetype.component.html',
  styleUrls: ['./inviteetype.component.css']
})
export class InviteeTypeComponent implements OnInit {
  @ViewChild('excelexport', { static: false }) excelexport!: ExcelExportComponent;
  private unsubscribe$: Subject<void> = new Subject<void>();
  headerInviteeType: PageHeader;
  entity: InviteeType = new InviteeType();
  editingEntity: InviteeType = new InviteeType();
  selectedInviteeType: InviteeType = new InviteeType();
  inviteetypes: any;
  inviteetypeColumns: any[];
  listView: boolean = true;
  formCaption: string = '';
  pipe = new DatePipe('en-US');
  emailcheck: boolean = true;
  defaultRowsCount: number;
  defaultPageSize: number;
  pageSkip: number = 0;
  pageSizes: any = [];
  saveDisabled: boolean = false;

  constructor(
    private _inviteetypeService: InviteeTypeService,
    private configService: ConfigService,
    private _coreSaveService: CoreSaveService,
    private messageService: MessageService,
    private notification: NotificationsService,
  ) {
    this.headerInviteeType = this.initPageHeader();
    this.defaultRowsCount = Number(this.configService.getConfigValue('defaultRowsCount'));
    this.defaultPageSize = Number(this.configService.getConfigValue('defaultPageSize'));
    this.pageSizes = this.configService.getConfigValue('pageSizes');

    this.inviteetypeColumns = [
      { field: "SlNo", title: 'SL No', filter: false, sortable: true, width: 50 },
      { field: "InviteeTypeName", title: 'Name', filter: true, sortable: true, width: 120 },
      { field: "Description", title: 'Description', filter: true, sortable: true, width: 120 },
      { field: "Code", title: 'Code', filter: true, sortable: true, width: 100 },
      { field: "Active", title: 'Active', filter: true, sortable: true, width: 100 },
    ];
    this.inviteetypes = [];
    this.getAllInviteeTypes();
  }
  onPaginationChange(event: any) {
    if (this.defaultPageSize != event.take) {
      this.defaultPageSize = event.take;
    }
    this.pageSkip = event.skip;
    this._inviteetypeService.getAllInviteeType('', this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 0, 0).subscribe((entities: Array<InviteeType>) => {
      this.inviteetypes = {
        data: entities,
        total: entities[0] ? entities[0].TotalCount : 0
      }
    });
  }

  onFilterChange(event: any): void {
    if (((event && event.filter && event.filter.filters[0] && event.filter.filters[0].filters[0]) != null)) {
      var filter = (event.filter.filters[0].filters[0].field + '|' + event.filter.filters[0].filters[0].value + ';');
      //1 for gridfilter type
      this._inviteetypeService.getAllInviteeType(filter, this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 1, 0).subscribe((inviteetypes: Array<InviteeType>) => {
        this.inviteetypes = {
          data: inviteetypes,
          total: inviteetypes[0] ? inviteetypes[0].TotalCount : 0
        }
      });
    }
  }
  getAllInviteeTypes() {
    this._inviteetypeService.getAllInviteeType('', Number(this.defaultPageSize), 1, 0, 0).subscribe((inviteetypes: Array<InviteeType>) => {
      this.inviteetypes = {
        data: inviteetypes,
        total: inviteetypes[0].TotalCount
      }
    });
  }
  ngOnInit(): void {
    this.messageService.activeCommonMessage.pipe(takeUntil(this.unsubscribe$)).subscribe((message: ICommonMessage | null) => {
      if (message?.eventName === 'delete_read_confirmation') {
        if (message?.param.action === "FA") {
          this._inviteetypeService.deleteInviteeType(this.selectedInviteeType.Invitee_Type_Id).subscribe((entity: any) => {
            this.notification.showSuccess('Deleted Successfully');
            this.clearInviteeType();
            this.getAllInviteeTypes();
          },
          )
        }
      }
    });
  }

  AlphabetsOnly(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);
    if (/^[a-zA-Z\s]*$/.test(inp)) {
      return true;
    } else {
      return false;
    }
  }
  initPageHeader(): PageHeader {
    let headerInviteeType = new PageHeader();
    headerInviteeType.PageCaption = "Invitee Type";
    headerInviteeType.IconClass = "bi bi-building";
    return headerInviteeType;
  }

  deleteInviteeType(event: any) {
    if (event.seletedRows[0]) {
      this.selectedInviteeType.Invitee_Type_Id = event.seletedRows[0];
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry ?",
          caption: "Invitee Type",
          returnKey: "delete_read_confirmation"
        }
      };
      this.messageService.sendCommonMessage(message);
    }
  }

  addInviteeType(event: any) {
    this.listView = false;
    this.clearInviteeType();
    this.formCaption = "Add Invitee Type";
  }

  editInviteeType(event: any): void {
    if (event.seletedRows[0]) {
      this._inviteetypeService.viewInviteeType(event.seletedRows[0]).subscribe((inviteetypes: Array<InviteeType>) => {
        let editInviteeType = inviteetypes[0] ? inviteetypes[0] : new InviteeType();
        if (editInviteeType) {
          this.editingEntity = editInviteeType;
          this.entity = { ...this.editingEntity };
          this.listView = false;
          this.formCaption = "Edit Invitee Type";
          this.entity.EntityMetaData = [
            { FieldName: 'InviteeTypeName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'InviteeType Name is required' },
            { FieldName: 'Code', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Code is required' },

          ];
        }
      });
    }
  }

  save(event: any): void {
    this.saveDisabled = true;
    let validations = this._coreSaveService.saveValidation(this.entity);
    if (validations.length === 0) {
      this._inviteetypeService.checkDuplication(this.entity.InviteeTypeName, this.entity.Invitee_Type_Id).subscribe((res) => {
        if (res.Success == false) {
          this.notification.showWarning('Invitee Type already exists');
          this.saveDisabled = false;
        }
        else {
          this._inviteetypeService.saveInviteeType(this.entity).subscribe(() => {
            if (this.entity.Invitee_Type_Id == "00000000-0000-0000-0000-000000000000") {
              this.notification.showSuccess('Saved Successfully');
            }
            else {
              this.notification.showSuccess('Updated Successfully');
            }
            this.listView = true;
            this.clearInviteeType();
            this.getAllInviteeTypes();
          })
        }
      });
    }

    else {
      this.saveDisabled = false;
    }
  }

  gotoBack(): void {
    this.listView = true;
    this.clearInviteeType();
  }
  refreshInviteeType(event: any): void {
    this.inviteetypes=[];
    this.getAllInviteeTypes();
  }
  clearInviteeType(): void {
    this.entity = new InviteeType();
    this.saveDisabled = false;
  }
  onExcelExport() {
    this.excelexport.save()
  }
  revertChanges(): void {
    this.entity = { ...this.editingEntity };
  }
  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
